export const translations = {
  en: {
    // Main page
    title: "NoQueue Charge",
    subtitle: "Find available Electrify America charging stations and avoid the wait",
    selectCounty: "Select County",
    loadingCounties: "Loading counties...",
    comingSoon: "Coming Soon",
    stations: "stations",
    station: "station",
    stationsIn: "Stations in",
    county: "County",
    
    // Station details
    ports: "ports",
    available: "available",
    totalPorts: "total ports",
    portsAvailable: "{available} of {total} charging ports available",
    
    // Navigation
    back: "Back",
    clear: "Clear Selection",
    
    // Empty states
    selectCountyPrompt: "Choose a county from the left to view available Electrify America charging stations.",
    noStationsFound: "No Electrify America charging stations found in this county.",
    
    // Loading states
    loadingStations: "Loading stations...",
    loadingStationInfo: "Loading station information...",
    loadingHistory: "Loading availability history...",
    
    // Error messages
    errorLoadingCounties: "Failed to load counties. Please try again later.",
    errorLoadingStations: "Failed to load charging stations. Please try again later.",
    
    // Language selector
    language: "Language",
    
    // Station detail page
    stationTitle: "Station",
    availabilityHistory: "Availability History (Last 24 Hours)",
    port: "Port",
    inUse: "In Use",
    notAvailable: "Not Available",
    scrollHint: "Scroll horizontally to see full timeline",
    min: "min",
    
    // Location features
    useCurrentLocation: "Use My Current Location",
    gettingLocation: "Getting your location...",
    searchPlaceholder: "Enter zipcode or city name",
    searchButton: "Search",
    clearSearch: "Clear",
    findNearestStations: "Find Nearest Stations",
    nearYourLocation: "Near Your Location",
    browseByArea: "Browse by Area",
    zipcode: "Zipcode",
    city: "City",
    address: "Address",
    getDirections: "Get Directions",
    updateLocation: "Update Location",
    locationError: "Location Error",
    locationPermissionDenied: "Location access was denied. Please enter your address manually or enable location permissions.",
    locationUnavailable: "Unable to determine your location. Please try searching by address.",
    locationTimeout: "Location request timed out. Please try again or search manually.",
    or: "or",
    nearbyStations: "Nearby Stations",
    newSearch: "New Search",
    tryDifferentLocation: "Try searching for a different location or zipcode.",
    
    // Distance and availability
    milesAway: "{distance} away",
    portsAvailableShort: "{available}/{total} available",
    
    // Busyness status badges
    noWait: "No Wait",
    shortWait: "Short Wait", 
    busy: "Busy",
    
    // Intelligence section
    busyHours: "Busy Hours",
    bestTimes: "Best Times",
    bestTimesToCharge: "Best Times to Charge",
    shortWaits: "Short Waits",
    crowded: "Crowded",
    busyHoursDescription: "This chart shows how busy this station typically gets throughout the day.",
    historyDetails: "24-Hour History Details",
    availableForMinutes: "Available for {minutes} min",
    inUseForMinutes: "In use for {minutes} min",
    downForMinutes: "Down for {minutes} min",
    down: "Down",
    
    // Feedback page
    feedbackTitle: "Feedback & Feature Requests",
    feedbackSubtitle: "Help us improve NoQueue Charge by sharing your feedback or suggesting new features",
    feedbackButton: "Send Feedback",
    feedbackType: "Type",
    subject: "Subject",
    message: "Message",
    subjectPlaceholder: "Brief description of your feedback",
    messagePlaceholder: "Please provide detailed feedback or describe the feature you'd like to see...",
    feedbackOption: "General Feedback",
    featureRequestOption: "Feature Request",
    bugReportOption: "Bug Report",
    otherOption: "Other",
    submitFeedback: "Send Feedback",
    submitting: "Sending...",
    feedbackSuccess: "Thank you for your feedback!",
    feedbackSuccessMessage: "We've received your message and will review it shortly. Your input helps us make NoQueue Charge better for everyone.",
    feedbackError: "Failed to send feedback",
    feedbackErrorMessage: "There was an error sending your feedback. Please try again later.",
    
    // Coverage information
    coverageStatus: "Now serving the entire United States",
    coverageDetails: "1,000+ Electrify America stations nationwide",

    // Sponsor
    enjoyingApp: "Enjoying this app?",
    buyMeACoffee: "Buy me a coffee",

    // Privacy Policy
    privacyTitle: "Privacy Policy",
    privacyLastUpdated: "Last updated: March 10, 2026",
    privacyIntroTitle: "Introduction",
    privacyIntroText: "NoQueue Charge (\"we\", \"our\", or \"us\") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use the NoQueue Charge mobile application and website (collectively, the \"Service\").",
    privacyCollectTitle: "Information We Collect",
    privacyAccountTitle: "Account Information",
    privacyAccountEmail: "Email address (when you create an account)",
    privacyAccountName: "Display name (optional, if provided during sign-up)",
    privacyAccountAuth: "Authentication identifiers from Google Sign-In or Apple Sign-In (if used)",
    privacyLocationTitle: "Location Information",
    privacyLocationDesc: "Approximate location to show nearby charging stations",
    privacyLocationWhen: "Location is accessed only while the app is in use (\"When In Use\" permission)",
    privacyLocationNoTrack: "We do not track or store your location history on our servers",
    privacyDeviceTitle: "Device Information",
    privacyDeviceToken: "Push notification token (to send you charger availability alerts)",
    privacyDeviceType: "Device type and operating system version (for compatibility)",
    privacyDeviceLang: "Language preference",
    privacyUsageTitle: "Usage Data",
    privacyUsageWatch: "Stations you choose to watch",
    privacyUsageNotif: "Notification preferences and schedules you configure",
    privacyUsagePrefs: "App settings and preferences",
    privacyHowUseTitle: "How We Use Your Information",
    privacyHowUseNearby: "Show charging stations near your location",
    privacyHowUseNotifs: "Send push notifications when watched chargers become available",
    privacyHowUseAuth: "Authenticate your account and manage your session",
    privacyHowUseSub: "Process and manage your subscription",
    privacyHowUseImprove: "Improve the Service and fix bugs",
    privacyThirdPartyTitle: "Third-Party Services",
    privacyThirdPartyIntro: "We use the following third-party services to operate the app:",
    privacyThirdFirebase: "Authentication, push notifications, and crash reporting",
    privacyThirdRevenueCat: "Subscription management and payment processing",
    privacyThirdMaps: "Directions and map display",
    privacyThirdPartyNote: "These services may collect information as described in their own privacy policies. We encourage you to review their policies.",
    privacyNoSellTitle: "We Do Not Sell Your Data",
    privacyNoSellText: "We do not sell, rent, or share your personal information with third parties for advertising or marketing purposes. We do not display ads in the app. Your data is used solely to provide and improve the Service.",
    privacyRetentionTitle: "Data Retention",
    privacyRetentionText: "We retain your account information for as long as your account is active. If you delete your account, we will delete your personal data from our systems within 30 days. Anonymized usage data may be retained for analytical purposes.",
    privacyRightsTitle: "Your Rights",
    privacyRightsIntro: "You have the right to:",
    privacyRightsAccess: "Access the personal data we hold about you",
    privacyRightsDelete: "Request deletion of your account and personal data",
    privacyRightsExport: "Request a copy of your data in a portable format",
    privacyRightsOptOut: "Opt out of push notifications at any time via app or device settings",
    privacyRightsHow: "To exercise these rights, contact us at support@noqueuecharge.com or use the account deletion feature in the app's Profile screen.",
    privacyChildrenTitle: "Children's Privacy",
    privacyChildrenText: "The Service is not directed at children under 13. We do not knowingly collect personal information from children under 13. If you believe we have collected such information, please contact us and we will promptly delete it.",
    privacyChangesTitle: "Changes to This Policy",
    privacyChangesText: "We may update this Privacy Policy from time to time. We will notify you of material changes by posting the updated policy in the app or on our website. Your continued use of the Service after changes constitutes acceptance of the updated policy.",
    privacyContactTitle: "Contact Us",
    privacyContactText: "If you have questions about this Privacy Policy or your personal data, please contact us at:",

    // Terms of Use
    termsTitle: "Terms of Use",
    termsLastUpdated: "Last updated: March 10, 2026",
    termsAcceptTitle: "Acceptance of Terms",
    termsAcceptText: "By downloading, installing, or using NoQueue Charge (the \"App\"), you agree to be bound by these Terms of Use (\"Terms\"). If you do not agree to these Terms, do not use the App.",
    termsServiceTitle: "Description of Service",
    termsServiceText: "NoQueue Charge provides real-time information about Electrify America electric vehicle charging stations across the United States. The Service includes:",
    termsServiceMap: "A real-time map of Electrify America charging stations with port availability status",
    termsServiceWatch: "The ability to watch stations and receive alerts when chargers become available",
    termsServiceNotifs: "Push notifications for charger availability changes",
    termsServicePredict: "AI-powered predictions for charger availability upon arrival",
    termsAccountTitle: "User Accounts",
    termsAccountText: "Some features require you to create an account. When you create an account, you agree to:",
    termsAccountAccurate: "Provide accurate and complete information",
    termsAccountSecure: "Keep your login credentials secure",
    termsAccountResponsible: "Be responsible for all activity under your account",
    termsSubTitle: "Subscriptions & Payments",
    termsSubFreeTitle: "Free Tier",
    termsSubFreeText: "The App can be used for free to browse all charging stations, view real-time port status, and get directions. Some advanced features require a paid subscription.",
    termsSubProTitle: "NoQueue Pro",
    termsSubProText: "NoQueue Pro is available as a monthly subscription at $2.99/month. Pro features include watching up to 5 stations, 60-second real-time alerts, customizable notification schedules, busy hour patterns, and AI-powered smart alerts.",
    termsSubAutoTitle: "Auto-Renewal",
    termsSubAutoText: "Subscriptions automatically renew at the end of each billing period unless you cancel at least 24 hours before the end of the current period. Your Apple ID or Google Play account will be charged for renewal within 24 hours prior to the end of the current period at the same price. You can manage and cancel your subscription in your device's subscription settings.",
    termsSubCancelTitle: "Cancellation",
    termsSubCancelText: "You can cancel your subscription at any time through your Apple App Store or Google Play Store subscription settings. Cancellation takes effect at the end of the current billing period. No refunds are provided for partial billing periods.",
    termsDisclaimerTitle: "Disclaimers",
    termsDisclaimerText: "Please be aware of the following:",
    termsDisclaimerAccuracy: "Charging station data is provided on an \"as is\" basis. We strive for accuracy but cannot guarantee that station status information is always current or correct.",
    termsDisclaimerDelay: "There may be delays between a charger's actual status change and what is displayed in the app.",
    termsDisclaimerPredict: "AI predictions are estimates based on historical patterns and should not be solely relied upon for travel planning decisions.",
    termsDisclaimerAffiliate: "NoQueue Charge is an independent application. It is not affiliated with, endorsed by, or sponsored by Electrify America or any charging network.",
    termsUseTitle: "Acceptable Use",
    termsUseText: "You agree not to:",
    termsUseNoReverse: "Reverse engineer, decompile, or disassemble the App",
    termsUseNoAbuse: "Use the App for any unlawful purpose or in violation of these Terms",
    termsUseNoAutomate: "Use automated systems or bots to access the App in a manner that exceeds reasonable use",
    termsUseNoResell: "Resell, redistribute, or sublicense access to the App or its data",
    termsIpTitle: "Intellectual Property",
    termsIpText: "The App, including its design, features, code, and content, is owned by NoQueue Charge and protected by intellectual property laws. You are granted a limited, non-exclusive, non-transferable license to use the App for personal, non-commercial purposes.",
    termsTerminationTitle: "Termination",
    termsTerminationText: "We may suspend or terminate your access to the App at any time if you violate these Terms. You may delete your account at any time through the app's Profile screen. Upon termination, your right to use the App ceases immediately.",
    termsLiabilityTitle: "Limitation of Liability",
    termsLiabilityText: "To the maximum extent permitted by law, NoQueue Charge shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the App. This includes, without limitation, damages resulting from reliance on charger availability information, missed charging opportunities, or travel delays. Our total liability shall not exceed the amount you paid for the App in the 12 months preceding the claim.",
    termsChangesTitle: "Changes to Terms",
    termsChangesText: "We may update these Terms from time to time. We will notify you of material changes by posting the updated Terms in the App or on our website. Your continued use of the App after changes constitutes acceptance of the updated Terms.",
    termsGoverningTitle: "Governing Law",
    termsGoverningText: "These Terms are governed by and construed in accordance with the laws of the State of California, United States, without regard to its conflict of law provisions.",
    termsContactTitle: "Contact Us",
    termsContactText: "If you have questions about these Terms, please contact us at:",
    termsViewPrivacy: "View our Privacy Policy",

    // App promotion
    getAppAlerts: "Get Charger Alerts",
    getAppAlertsDesc: "Get notified when a charger opens up",
    arrivalPrediction: "Know Before You Go",
    arrivalPredictionDesc: "Know if a charger will be available when you arrive",
    downloadApp: "Download on the App Store",
    openInApp: "Open in App",
    getApp: "GET APP",
    scanToDownload: "Scan to download",
    comingSoonAndroid: "Coming Soon to Android",
    appPromoTitle: "Never wait at a charger",
    appPromoFeature1: "Get alerted when a port opens",
    appPromoFeature2: "AI predicts availability at arrival",
    appPromoFeature3: "Watch multiple stations at once",
    tryTheApp: "Try the app for a better experience",
    viewInAppStore: "VIEW",
    appName: "NoQueue Charge",
    appTagline: "Free - Real-time EV charging",
    notifyEmail: "Enter email for Android launch",
    textMeTheApp: "Text Me the Link",
    enterPhone: "Phone number",
    orDivider: "or",
    appPopupTitle: "Charge smarter with the app",
    appPopupDesc: "Get real-time alerts, AI predictions, and never wait at a charger again."
  },

  es: {
    // Main page
    title: "NoQueue Charge",
    subtitle: "Encuentra estaciones de carga Electrify America disponibles y evita la espera",
    selectCounty: "Seleccionar Región",
    loadingCounties: "Cargando regiones...",
    comingSoon: "Próximamente",
    stations: "estaciones",
    station: "estación", 
    stationsIn: "Estaciones en",
    county: "Región",
    
    // Station details
    ports: "cargadores",
    available: "disponibles",
    totalPorts: "cargadores totales",
    portsAvailable: "{available}/{total} cargadores disponibles",
    
    // Navigation
    back: "Atrás",
    clear: "Limpiar Selección",
    
    // Empty states
    selectCountyPrompt: "Selecciona una región de la izquierda para ver las estaciones de carga Electrify America disponibles.",
    noStationsFound: "No se encontraron estaciones de carga Electrify America en esta región.",
    
    // Loading states
    loadingStations: "Cargando estaciones...",
    loadingStationInfo: "Cargando información de la estación...",
    loadingHistory: "Cargando historial de disponibilidad...",
    
    // Error messages
    errorLoadingCounties: "Error al cargar las regiones. Por favor, inténtalo de nuevo más tarde.",
    errorLoadingStations: "Error al cargar las estaciones de carga. Por favor, inténtalo de nuevo más tarde.",
    
    // Language selector
    language: "Idioma",
    
    // Station detail page
    stationTitle: "Estación",
    availabilityHistory: "Historial de Disponibilidad (Últimas 24 Horas)",
    port: "Cargador",
    inUse: "En Uso",
    notAvailable: "No Disponible",
    scrollHint: "Desliza horizontalmente para ver la línea de tiempo completa",
    min: "min",
    
    // Location features
    useCurrentLocation: "Usar Mi Ubicación Actual",
    gettingLocation: "Obteniendo tu ubicación...",
    searchPlaceholder: "Ingresa código postal o nombre de ciudad",
    searchButton: "Buscar",
    clearSearch: "Limpiar",
    findNearestStations: "Encuentra Estaciones Cercanas",
    nearYourLocation: "Cerca de Tu Ubicación",
    browseByArea: "Navegar por Área",
    zipcode: "Código Postal",
    city: "Ciudad",
    address: "Dirección",
    getDirections: "Obtener Direcciones",
    updateLocation: "Actualizar Ubicación",
    locationError: "Error de Ubicación",
    locationPermissionDenied: "Se denegó el acceso a la ubicación. Por favor ingresa tu dirección manualmente o habilita los permisos de ubicación.",
    locationUnavailable: "No se puede determinar tu ubicación. Por favor intenta buscar por dirección.",
    locationTimeout: "La solicitud de ubicación expiró. Por favor intenta de nuevo o busca manualmente.",
    or: "o",
    nearbyStations: "Estaciones Cercanas",
    newSearch: "Nueva Búsqueda",
    tryDifferentLocation: "Intenta buscar una ubicación o código postal diferente.",
    
    // Distance and availability
    milesAway: "{distance} de distancia",
    portsAvailableShort: "{available}/{total} disponibles",
    
    // Busyness status badges
    noWait: "Sin Espera",
    shortWait: "Espera Corta",
    busy: "Ocupado",
    
    // Intelligence section
    busyHours: "Horas Ocupadas",
    bestTimes: "Mejores Horarios",
    bestTimesToCharge: "Mejores Horarios para Cargar",
    shortWaits: "Esperas Cortas",
    crowded: "Saturado",
    busyHoursDescription: "Este gráfico muestra qué tan ocupada está típicamente esta estación durante el día.",
    historyDetails: "Detalles del Historial de 24 Horas",
    availableForMinutes: "Disponible por {minutes} min",
    inUseForMinutes: "En uso por {minutes} min",
    downForMinutes: "Fuera de servicio por {minutes} min",
    down: "Fuera de servicio",
    
    // Feedback page
    feedbackTitle: "Comentarios y Solicitudes de Funciones",
    feedbackSubtitle: "Ayúdanos a mejorar NoQueue Charge compartiendo tus comentarios o sugiriendo nuevas funciones",
    feedbackButton: "Enviar Comentarios",
    feedbackType: "Tipo",
    subject: "Asunto",
    message: "Mensaje",
    subjectPlaceholder: "Descripción breve de tus comentarios",
    messagePlaceholder: "Por favor proporciona comentarios detallados o describe la función que te gustaría ver...",
    feedbackOption: "Comentarios Generales",
    featureRequestOption: "Solicitud de Función",
    bugReportOption: "Reporte de Error",
    otherOption: "Otro",
    submitFeedback: "Enviar Comentarios",
    submitting: "Enviando...",
    feedbackSuccess: "¡Gracias por tus comentarios!",
    feedbackSuccessMessage: "Hemos recibido tu mensaje y lo revisaremos pronto. Tu aporte nos ayuda a hacer NoQueue Charge mejor para todos.",
    feedbackError: "Error al enviar comentarios",
    feedbackErrorMessage: "Hubo un error al enviar tus comentarios. Por favor intenta de nuevo más tarde.",
    
    // Coverage information
    coverageStatus: "Ahora sirviendo todo Estados Unidos",
    coverageDetails: "1,000+ estaciones Electrify America a nivel nacional",

    // Sponsor
    enjoyingApp: "¿Te gusta esta aplicación?",
    buyMeACoffee: "Invítame un café",

    // Privacy Policy
    privacyTitle: "Política de Privacidad",
    privacyLastUpdated: "Última actualización: 10 de marzo de 2026",
    privacyIntroTitle: "Introducción",
    privacyIntroText: "NoQueue Charge (\"nosotros\" o \"nuestro\") se compromete a proteger su privacidad. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos su información cuando utiliza la aplicación móvil y el sitio web de NoQueue Charge (colectivamente, el \"Servicio\").",
    privacyCollectTitle: "Información que Recopilamos",
    privacyAccountTitle: "Información de la Cuenta",
    privacyAccountEmail: "Dirección de correo electrónico (al crear una cuenta)",
    privacyAccountName: "Nombre para mostrar (opcional, si se proporciona durante el registro)",
    privacyAccountAuth: "Identificadores de autenticación de Google Sign-In o Apple Sign-In (si se utilizan)",
    privacyLocationTitle: "Información de Ubicación",
    privacyLocationDesc: "Ubicación aproximada para mostrar estaciones de carga cercanas",
    privacyLocationWhen: "La ubicación solo se accede mientras la app está en uso (permiso \"Durante el Uso\")",
    privacyLocationNoTrack: "No rastreamos ni almacenamos su historial de ubicación en nuestros servidores",
    privacyDeviceTitle: "Información del Dispositivo",
    privacyDeviceToken: "Token de notificaciones push (para enviar alertas de disponibilidad)",
    privacyDeviceType: "Tipo de dispositivo y versión del sistema operativo (para compatibilidad)",
    privacyDeviceLang: "Preferencia de idioma",
    privacyUsageTitle: "Datos de Uso",
    privacyUsageWatch: "Estaciones que elige vigilar",
    privacyUsageNotif: "Preferencias y horarios de notificación que configure",
    privacyUsagePrefs: "Configuraciones y preferencias de la app",
    privacyHowUseTitle: "Cómo Usamos Su Información",
    privacyHowUseNearby: "Mostrar estaciones de carga cerca de su ubicación",
    privacyHowUseNotifs: "Enviar notificaciones push cuando los cargadores vigilados estén disponibles",
    privacyHowUseAuth: "Autenticar su cuenta y gestionar su sesión",
    privacyHowUseSub: "Procesar y gestionar su suscripción",
    privacyHowUseImprove: "Mejorar el Servicio y corregir errores",
    privacyThirdPartyTitle: "Servicios de Terceros",
    privacyThirdPartyIntro: "Utilizamos los siguientes servicios de terceros para operar la app:",
    privacyThirdFirebase: "Autenticación, notificaciones push e informes de errores",
    privacyThirdRevenueCat: "Gestión de suscripciones y procesamiento de pagos",
    privacyThirdMaps: "Direcciones y visualización de mapas",
    privacyThirdPartyNote: "Estos servicios pueden recopilar información según sus propias políticas de privacidad. Le recomendamos revisar sus políticas.",
    privacyNoSellTitle: "No Vendemos Sus Datos",
    privacyNoSellText: "No vendemos, alquilamos ni compartimos su información personal con terceros con fines publicitarios o de marketing. No mostramos anuncios en la app. Sus datos se utilizan únicamente para proporcionar y mejorar el Servicio.",
    privacyRetentionTitle: "Retención de Datos",
    privacyRetentionText: "Conservamos la información de su cuenta mientras esté activa. Si elimina su cuenta, borraremos sus datos personales de nuestros sistemas en un plazo de 30 días. Los datos de uso anónimos pueden conservarse con fines analíticos.",
    privacyRightsTitle: "Sus Derechos",
    privacyRightsIntro: "Usted tiene derecho a:",
    privacyRightsAccess: "Acceder a los datos personales que tenemos sobre usted",
    privacyRightsDelete: "Solicitar la eliminación de su cuenta y datos personales",
    privacyRightsExport: "Solicitar una copia de sus datos en formato portátil",
    privacyRightsOptOut: "Desactivar las notificaciones push en cualquier momento desde la app o la configuración del dispositivo",
    privacyRightsHow: "Para ejercer estos derechos, contáctenos en support@noqueuecharge.com o use la función de eliminación de cuenta en la pantalla de Perfil de la app.",
    privacyChildrenTitle: "Privacidad de los Niños",
    privacyChildrenText: "El Servicio no está dirigido a menores de 13 años. No recopilamos intencionalmente información personal de menores de 13 años. Si cree que hemos recopilado dicha información, contáctenos y la eliminaremos de inmediato.",
    privacyChangesTitle: "Cambios en Esta Política",
    privacyChangesText: "Podemos actualizar esta Política de Privacidad periódicamente. Le notificaremos de cambios importantes publicando la política actualizada en la app o en nuestro sitio web. Su uso continuado del Servicio después de los cambios constituye la aceptación de la política actualizada.",
    privacyContactTitle: "Contáctenos",
    privacyContactText: "Si tiene preguntas sobre esta Política de Privacidad o sus datos personales, contáctenos en:",

    // Terms of Use
    termsTitle: "Términos de Uso",
    termsLastUpdated: "Última actualización: 10 de marzo de 2026",
    termsAcceptTitle: "Aceptación de los Términos",
    termsAcceptText: "Al descargar, instalar o usar NoQueue Charge (la \"App\"), usted acepta estar sujeto a estos Términos de Uso (\"Términos\"). Si no está de acuerdo con estos Términos, no use la App.",
    termsServiceTitle: "Descripción del Servicio",
    termsServiceText: "NoQueue Charge proporciona información en tiempo real sobre estaciones de carga de vehículos eléctricos Electrify America en todo Estados Unidos. El Servicio incluye:",
    termsServiceMap: "Un mapa en tiempo real de estaciones de carga con estado de disponibilidad de puertos",
    termsServiceWatch: "La capacidad de vigilar estaciones y recibir alertas cuando los cargadores estén disponibles",
    termsServiceNotifs: "Notificaciones push para cambios en la disponibilidad de cargadores",
    termsServicePredict: "Predicciones impulsadas por IA sobre la disponibilidad de cargadores a su llegada",
    termsAccountTitle: "Cuentas de Usuario",
    termsAccountText: "Algunas funciones requieren crear una cuenta. Al crear una cuenta, usted acepta:",
    termsAccountAccurate: "Proporcionar información precisa y completa",
    termsAccountSecure: "Mantener sus credenciales de acceso seguras",
    termsAccountResponsible: "Ser responsable de toda la actividad bajo su cuenta",
    termsSubTitle: "Suscripciones y Pagos",
    termsSubFreeTitle: "Plan Gratuito",
    termsSubFreeText: "La App se puede usar de forma gratuita para explorar todas las estaciones de carga, ver el estado en tiempo real y obtener direcciones. Algunas funciones avanzadas requieren una suscripción de pago.",
    termsSubProTitle: "NoQueue Pro",
    termsSubProText: "NoQueue Pro está disponible como suscripción mensual a $2.99/mes. Las funciones Pro incluyen vigilar hasta 5 estaciones, alertas en tiempo real cada 60 segundos, horarios de notificación personalizables, patrones de horas ocupadas y alertas inteligentes con IA.",
    termsSubAutoTitle: "Renovación Automática",
    termsSubAutoText: "Las suscripciones se renuevan automáticamente al final de cada período de facturación a menos que cancele al menos 24 horas antes del final del período actual. Se cobrará a su cuenta de Apple ID o Google Play la renovación dentro de las 24 horas anteriores al final del período actual al mismo precio. Puede gestionar y cancelar su suscripción en la configuración de suscripciones de su dispositivo.",
    termsSubCancelTitle: "Cancelación",
    termsSubCancelText: "Puede cancelar su suscripción en cualquier momento a través de la configuración de suscripciones de Apple App Store o Google Play Store. La cancelación entra en vigor al final del período de facturación actual. No se proporcionan reembolsos por períodos parciales.",
    termsDisclaimerTitle: "Descargos de Responsabilidad",
    termsDisclaimerText: "Tenga en cuenta lo siguiente:",
    termsDisclaimerAccuracy: "Los datos de las estaciones de carga se proporcionan \"tal cual\". Nos esforzamos por la precisión, pero no podemos garantizar que la información del estado sea siempre actual o correcta.",
    termsDisclaimerDelay: "Puede haber retrasos entre el cambio real del estado de un cargador y lo que se muestra en la app.",
    termsDisclaimerPredict: "Las predicciones de IA son estimaciones basadas en patrones históricos y no deben ser la única base para decisiones de planificación de viaje.",
    termsDisclaimerAffiliate: "NoQueue Charge es una aplicación independiente. No está afiliada, respaldada ni patrocinada por Electrify America ni ninguna red de carga.",
    termsUseTitle: "Uso Aceptable",
    termsUseText: "Usted acepta no:",
    termsUseNoReverse: "Realizar ingeniería inversa, descompilar o desensamblar la App",
    termsUseNoAbuse: "Usar la App para cualquier propósito ilegal o en violación de estos Términos",
    termsUseNoAutomate: "Usar sistemas automatizados o bots para acceder a la App de manera que exceda el uso razonable",
    termsUseNoResell: "Revender, redistribuir o sublicenciar el acceso a la App o sus datos",
    termsIpTitle: "Propiedad Intelectual",
    termsIpText: "La App, incluyendo su diseño, funciones, código y contenido, es propiedad de NoQueue Charge y está protegida por leyes de propiedad intelectual. Se le otorga una licencia limitada, no exclusiva e intransferible para usar la App con fines personales y no comerciales.",
    termsTerminationTitle: "Terminación",
    termsTerminationText: "Podemos suspender o terminar su acceso a la App en cualquier momento si viola estos Términos. Puede eliminar su cuenta en cualquier momento a través de la pantalla de Perfil de la app. Tras la terminación, su derecho a usar la App cesa inmediatamente.",
    termsLiabilityTitle: "Limitación de Responsabilidad",
    termsLiabilityText: "En la máxima medida permitida por la ley, NoQueue Charge no será responsable de ningún daño indirecto, incidental, especial, consecuente o punitivo derivado de su uso de la App. Esto incluye, sin limitación, daños por la confianza en la información de disponibilidad, oportunidades de carga perdidas o retrasos en viajes. Nuestra responsabilidad total no excederá la cantidad que pagó por la App en los 12 meses anteriores a la reclamación.",
    termsChangesTitle: "Cambios en los Términos",
    termsChangesText: "Podemos actualizar estos Términos periódicamente. Le notificaremos de cambios importantes publicando los Términos actualizados en la App o en nuestro sitio web. Su uso continuado de la App después de los cambios constituye la aceptación de los Términos actualizados.",
    termsGoverningTitle: "Ley Aplicable",
    termsGoverningText: "Estos Términos se rigen e interpretan de acuerdo con las leyes del Estado de California, Estados Unidos, sin tener en cuenta sus disposiciones sobre conflictos de leyes.",
    termsContactTitle: "Contáctenos",
    termsContactText: "Si tiene preguntas sobre estos Términos, contáctenos en:",
    termsViewPrivacy: "Ver nuestra Política de Privacidad",

    // App promotion
    getAppAlerts: "Recibe alertas de cargadores",
    getAppAlertsDesc: "Recibe notificaciones cuando un cargador esté disponible",
    arrivalPrediction: "Planifica antes de ir",
    arrivalPredictionDesc: "Sabe si un cargador estará disponible cuando llegues",
    downloadApp: "Descargar en App Store",
    openInApp: "Abrir en la app",
    getApp: "OBTENER",
    scanToDownload: "Escanea para descargar",
    comingSoonAndroid: "Próximamente en Android",
    appPromoTitle: "Nunca esperes en un cargador",
    appPromoFeature1: "Alerta cuando un puerto se abre",
    appPromoFeature2: "IA predice disponibilidad al llegar",
    appPromoFeature3: "Vigila varias estaciones a la vez",
    tryTheApp: "Prueba la app para una mejor experiencia",
    viewInAppStore: "VER",
    appName: "NoQueue Charge",
    appTagline: "Gratis - Carga EV en tiempo real",
    notifyEmail: "Ingresa email para lanzamiento Android",
    textMeTheApp: "Envíame el enlace",
    enterPhone: "Número de teléfono",
    orDivider: "o",
    appPopupTitle: "Carga más inteligente con la app",
    appPopupDesc: "Alertas en tiempo real, predicciones IA, y nunca esperes en un cargador."
  },

  zh: {
    // Main page
    title: "NoQueue Charge",
    subtitle: "查找可用的 Electrify America 充电站，免排队直接充电",
    selectCounty: "选择地区",
    loadingCounties: "正在加载地区...",
    comingSoon: "即将开放",
    stations: "个充电站",
    station: "个充电站",
    stationsIn: "充电站 -",
    county: "地区",
    
    // Station details
    ports: "个充电桩",
    available: "可用",
    totalPorts: "总充电桩数",
    portsAvailable: "{available}/{total} 个充电桩可用",
    
    // Navigation
    back: "返回",
    clear: "清除选择",
    
    // Empty states
    selectCountyPrompt: "请从左侧选择一个地区，查看该区域内可用的 Electrify America 充电站。",
    noStationsFound: "该地区暂无 Electrify America 充电站。",
    
    // Loading states
    loadingStations: "正在加载充电站...",
    loadingStationInfo: "正在加载充电站信息...",
    loadingHistory: "正在加载可用性记录...",
    
    // Error messages
    errorLoadingCounties: "加载地区信息失败，请稍后重试。",
    errorLoadingStations: "加载充电站信息失败，请稍后重试。",
    
    // Language selector
    language: "语言",
    
    // Station detail page
    stationTitle: "充电站",
    availabilityHistory: "可用性记录（近24小时）",
    port: "充电桩",
    inUse: "使用中",
    notAvailable: "不可用",
    scrollHint: "左右滑动查看完整时间轴",
    min: "分钟",
    
    // Location features
    useCurrentLocation: "使用我的当前位置",
    gettingLocation: "正在获取您的位置...",
    searchPlaceholder: "输入邮政编码或城市名称",
    searchButton: "搜索",
    clearSearch: "清除",
    findNearestStations: "查找最近的充电站",
    nearYourLocation: "您附近",
    browseByArea: "按地区浏览",
    zipcode: "邮政编码",
    city: "城市",
    address: "地址",
    getDirections: "获取方向",
    updateLocation: "更新位置",
    locationError: "位置错误",
    locationPermissionDenied: "位置访问被拒绝。请手动输入您的地址或启用位置权限。",
    locationUnavailable: "无法确定您的位置。请尝试按地址搜索。",
    locationTimeout: "位置请求超时。请重试或手动搜索。",
    or: "或",
    nearbyStations: "附近充电站",
    newSearch: "新搜索",
    tryDifferentLocation: "请尝试搜索不同的位置或邮政编码。",
    
    // Distance and availability
    milesAway: "{distance} 英里",
    portsAvailableShort: "{available}/{total} 可用",
    
    // Busyness status badges
    noWait: "无需等待",
    shortWait: "短暂等待",
    busy: "繁忙",
    
    // Intelligence section
    busyHours: "繁忙时段",
    bestTimes: "最佳时间",
    bestTimesToCharge: "最佳充电时间",
    shortWaits: "短暂等待",
    crowded: "拥挤",
    busyHoursDescription: "此图表显示该充电站在一天中通常有多繁忙。",
    historyDetails: "24小时历史详情",
    availableForMinutes: "可用 {minutes} 分钟",
    inUseForMinutes: "使用中 {minutes} 分钟",
    downForMinutes: "故障 {minutes} 分钟",
    down: "故障",
    
    // Feedback page
    feedbackTitle: "反馈与功能建议",
    feedbackSubtitle: "通过分享您的反馈或建议新功能来帮助我们改进 NoQueue Charge",
    feedbackButton: "发送反馈",
    feedbackType: "类型",
    subject: "主题",
    message: "消息",
    subjectPlaceholder: "简要描述您的反馈",
    messagePlaceholder: "请提供详细的反馈或描述您希望看到的功能...",
    feedbackOption: "一般反馈",
    featureRequestOption: "功能请求",
    bugReportOption: "错误报告",
    otherOption: "其他",
    submitFeedback: "发送反馈",
    submitting: "发送中...",
    feedbackSuccess: "感谢您的反馈！",
    feedbackSuccessMessage: "我们已收到您的消息，将很快进行审核。您的意见帮助我们为每个人改进 NoQueue Charge。",
    feedbackError: "发送反馈失败",
    feedbackErrorMessage: "发送反馈时出现错误。请稍后重试。",
    
    // Coverage information
    coverageStatus: "现已服务全美国",
    coverageDetails: "全国1,000+个Electrify America充电站",

    // Sponsor
    enjoyingApp: "喜欢这个应用吗？",
    buyMeACoffee: "请我喝咖啡",

    // Privacy Policy
    privacyTitle: "隐私政策",
    privacyLastUpdated: "最后更新：2026年3月10日",
    privacyIntroTitle: "简介",
    privacyIntroText: "NoQueue Charge（\u201c我们\u201d）致力于保护您的隐私。本隐私政策说明我们在您使用 NoQueue Charge 移动应用和网站（统称\u201c服务\u201d）时如何收集、使用和保护您的信息。",
    privacyCollectTitle: "我们收集的信息",
    privacyAccountTitle: "账户信息",
    privacyAccountEmail: "电子邮件地址（创建账户时）",
    privacyAccountName: "显示名称（可选，注册时提供）",
    privacyAccountAuth: "Google 登录或 Apple 登录的身份验证标识符（如使用）",
    privacyLocationTitle: "位置信息",
    privacyLocationDesc: "大致位置，用于显示附近的充电站",
    privacyLocationWhen: "仅在应用使用期间访问位置（\u201c使用期间\u201d权限）",
    privacyLocationNoTrack: "我们不会在服务器上跟踪或存储您的位置历史",
    privacyDeviceTitle: "设备信息",
    privacyDeviceToken: "推送通知令牌（用于发送充电桩可用性提醒）",
    privacyDeviceType: "设备类型和操作系统版本（用于兼容性）",
    privacyDeviceLang: "语言偏好",
    privacyUsageTitle: "使用数据",
    privacyUsageWatch: "您选择监控的充电站",
    privacyUsageNotif: "您配置的通知偏好和时间表",
    privacyUsagePrefs: "应用设置和偏好",
    privacyHowUseTitle: "我们如何使用您的信息",
    privacyHowUseNearby: "显示您附近的充电站",
    privacyHowUseNotifs: "当监控的充电桩变为可用时发送推送通知",
    privacyHowUseAuth: "验证您的账户并管理您的会话",
    privacyHowUseSub: "处理和管理您的订阅",
    privacyHowUseImprove: "改进服务并修复问题",
    privacyThirdPartyTitle: "第三方服务",
    privacyThirdPartyIntro: "我们使用以下第三方服务来运营应用：",
    privacyThirdFirebase: "身份验证、推送通知和崩溃报告",
    privacyThirdRevenueCat: "订阅管理和支付处理",
    privacyThirdMaps: "导航和地图显示",
    privacyThirdPartyNote: "这些服务可能会根据其自身的隐私政策收集信息。我们建议您查阅它们的政策。",
    privacyNoSellTitle: "我们不出售您的数据",
    privacyNoSellText: "我们不会为了广告或营销目的向第三方出售、出租或分享您的个人信息。我们不在应用中展示广告。您的数据仅用于提供和改进服务。",
    privacyRetentionTitle: "数据保留",
    privacyRetentionText: "我们在您的账户活跃期间保留您的账户信息。如果您删除账户，我们将在30天内从系统中删除您的个人数据。匿名使用数据可能会为分析目的而保留。",
    privacyRightsTitle: "您的权利",
    privacyRightsIntro: "您有权：",
    privacyRightsAccess: "访问我们持有的关于您的个人数据",
    privacyRightsDelete: "要求删除您的账户和个人数据",
    privacyRightsExport: "要求以可移植格式获取您的数据副本",
    privacyRightsOptOut: "随时通过应用或设备设置退出推送通知",
    privacyRightsHow: "要行使这些权利，请通过 support@noqueuecharge.com 联系我们，或使用应用\u201c个人资料\u201d页面中的账户删除功能。",
    privacyChildrenTitle: "儿童隐私",
    privacyChildrenText: "本服务不面向13岁以下的儿童。我们不会有意收集13岁以下儿童的个人信息。如果您认为我们收集了此类信息，请联系我们，我们将立即删除。",
    privacyChangesTitle: "政策变更",
    privacyChangesText: "我们可能会不时更新本隐私政策。我们将通过在应用或网站上发布更新的政策来通知您重大变更。您在变更后继续使用服务即表示接受更新的政策。",
    privacyContactTitle: "联系我们",
    privacyContactText: "如果您对本隐私政策或您的个人数据有疑问，请通过以下方式联系我们：",

    // Terms of Use
    termsTitle: "使用条款",
    termsLastUpdated: "最后更新：2026年3月10日",
    termsAcceptTitle: "条款接受",
    termsAcceptText: "下载、安装或使用 NoQueue Charge（\u201c应用\u201d）即表示您同意受这些使用条款（\u201c条款\u201d）的约束。如果您不同意这些条款，请勿使用本应用。",
    termsServiceTitle: "服务描述",
    termsServiceText: "NoQueue Charge 提供关于美国各地 Electrify America 电动汽车充电站的实时信息。服务包括：",
    termsServiceMap: "实时充电站地图，显示充电端口可用状态",
    termsServiceWatch: "监控充电站并在充电桩变为可用时接收提醒的功能",
    termsServiceNotifs: "充电桩可用性变化的推送通知",
    termsServicePredict: "基于AI的到达时充电桩可用性预测",
    termsAccountTitle: "用户账户",
    termsAccountText: "某些功能需要创建账户。创建账户时，您同意：",
    termsAccountAccurate: "提供准确和完整的信息",
    termsAccountSecure: "保管好您的登录凭据",
    termsAccountResponsible: "对您账户下的所有活动负责",
    termsSubTitle: "订阅与付款",
    termsSubFreeTitle: "免费版",
    termsSubFreeText: "应用可免费使用，包括浏览所有充电站、查看实时端口状态和获取导航。部分高级功能需要付费订阅。",
    termsSubProTitle: "NoQueue Pro",
    termsSubProText: "NoQueue Pro 提供月度订阅，价格为 $2.99/月。Pro 功能包括同时监控最多5个充电站、60秒实时提醒、可自定义通知时间表、繁忙时段模式和AI智能提醒。",
    termsSubAutoTitle: "自动续订",
    termsSubAutoText: "订阅会在每个计费周期结束时自动续订，除非您在当前周期结束前至少24小时取消。您的 Apple ID 或 Google Play 账户将在当前周期结束前24小时内以相同价格收取续订费用。您可以在设备的订阅设置中管理和取消订阅。",
    termsSubCancelTitle: "取消",
    termsSubCancelText: "您可以随时通过 Apple App Store 或 Google Play Store 的订阅设置取消订阅。取消将在当前计费周期结束时生效。不提供部分计费周期的退款。",
    termsDisclaimerTitle: "免责声明",
    termsDisclaimerText: "请注意以下事项：",
    termsDisclaimerAccuracy: "充电站数据按\u201c原样\u201d提供。我们力求准确，但不能保证站点状态信息始终是最新或正确的。",
    termsDisclaimerDelay: "充电桩实际状态变化与应用中显示之间可能存在延迟。",
    termsDisclaimerPredict: "AI预测是基于历史模式的估计，不应作为旅行计划决策的唯一依据。",
    termsDisclaimerAffiliate: "NoQueue Charge 是一款独立应用。与 Electrify America 或任何充电网络无关联、未获认可或赞助。",
    termsUseTitle: "可接受的使用",
    termsUseText: "您同意不会：",
    termsUseNoReverse: "对应用进行逆向工程、反编译或反汇编",
    termsUseNoAbuse: "将应用用于任何非法目的或违反这些条款",
    termsUseNoAutomate: "使用自动化系统或机器人以超出合理使用的方式访问应用",
    termsUseNoResell: "转售、再分发或转授权访问应用或其数据",
    termsIpTitle: "知识产权",
    termsIpText: "应用，包括其设计、功能、代码和内容，归 NoQueue Charge 所有，受知识产权法保护。您被授予有限的、非独占的、不可转让的许可，用于个人非商业用途使用该应用。",
    termsTerminationTitle: "终止",
    termsTerminationText: "如果您违反这些条款，我们可能随时暂停或终止您对应用的访问。您可以随时通过应用的\u201c个人资料\u201d页面删除您的账户。终止后，您使用应用的权利立即停止。",
    termsLiabilityTitle: "责任限制",
    termsLiabilityText: "在法律允许的最大范围内，NoQueue Charge 不对因您使用应用而产生的任何间接、附带、特殊、后果性或惩罚性损害承担责任。这包括但不限于因依赖充电桩可用性信息、错失充电机会或旅行延误而造成的损害。我们的总责任不超过您在索赔前12个月内为应用支付的金额。",
    termsChangesTitle: "条款变更",
    termsChangesText: "我们可能会不时更新这些条款。我们将通过在应用或网站上发布更新的条款来通知您重大变更。您在变更后继续使用应用即表示接受更新的条款。",
    termsGoverningTitle: "适用法律",
    termsGoverningText: "这些条款受美国加利福尼亚州法律管辖并据其解释，不考虑其法律冲突条款。",
    termsContactTitle: "联系我们",
    termsContactText: "如果您对这些条款有疑问，请通过以下方式联系我们：",
    termsViewPrivacy: "查看我们的隐私政策",

    // App promotion
    getAppAlerts: "获取充电桩提醒",
    getAppAlertsDesc: "充电桩空闲时收到通知",
    arrivalPrediction: "出发前了解",
    arrivalPredictionDesc: "预知到达时充电桩是否可用",
    downloadApp: "在 App Store 下载",
    openInApp: "在应用中打开",
    getApp: "获取应用",
    scanToDownload: "扫码下载",
    comingSoonAndroid: "Android 版即将推出",
    appPromoTitle: "充电不再排队",
    appPromoFeature1: "充电桩空出来时立刻通知你",
    appPromoFeature2: "AI预测到达时是否有空位",
    appPromoFeature3: "同时监控多个充电站",
    tryTheApp: "试试应用，获得更好的体验",
    viewInAppStore: "查看",
    appName: "NoQueue Charge",
    appTagline: "免费 - 实时电动车充电",
    notifyEmail: "输入邮箱以获取 Android 上线通知",
    textMeTheApp: "发送链接给我",
    enterPhone: "手机号码",
    orDivider: "或",
    appPopupTitle: "用应用更智能地充电",
    appPopupDesc: "实时提醒、AI预测，从此不再排队等充电。"
  },

  ko: {
    // Main page
    title: "NoQueue Charge",
    subtitle: "Electrify America 충전소 실시간 현황을 확인하고 대기 없이 충전하세요",
    selectCounty: "지역 선택",
    loadingCounties: "지역 정보 로딩 중...",
    comingSoon: "서비스 예정",
    stations: "개 충전소",
    station: "개 충전소",
    stationsIn: "충전소 -",
    county: "지역",
    
    // Station details
    ports: "개 충전기",
    available: "사용 가능",
    totalPorts: "총 충전기 수",
    portsAvailable: "{available}/{total}개 충전기 이용 가능",
    
    // Navigation
    back: "뒤로",
    clear: "선택 초기화",
    
    // Empty states
    selectCountyPrompt: "왼쪽에서 지역을 선택하시면 해당 지역의 Electrify America 충전소를 확인하실 수 있습니다.",
    noStationsFound: "이 지역에는 Electrify America 충전소가 없습니다.",
    
    // Loading states
    loadingStations: "충전소 정보 로딩 중...",
    loadingStationInfo: "충전소 세부 정보 로딩 중...",
    loadingHistory: "이용 현황 기록 로딩 중...",
    
    // Error messages
    errorLoadingCounties: "지역 정보를 불러오는데 실패했습니다. 잠시 후 다시 시도해주세요.",
    errorLoadingStations: "충전소 정보를 불러오는데 실패했습니다. 잠시 후 다시 시도해주세요.",
    
    // Language selector
    language: "언어",
    
    // Station detail page
    stationTitle: "충전소",
    availabilityHistory: "이용 현황 기록 (최근 24시간)",
    port: "충전기",
    inUse: "사용 중",
    notAvailable: "이용 불가",
    scrollHint: "좌우로 스크롤하여 전체 타임라인을 확인하세요",
    min: "분",
    
    // Location features
    useCurrentLocation: "현재 위치 사용하기",
    gettingLocation: "위치를 찾고 있습니다...",
    searchPlaceholder: "우편번호 또는 도시명을 입력하세요",
    searchButton: "검색",
    clearSearch: "지우기",
    findNearestStations: "가장 가까운 충전소 찾기",
    nearYourLocation: "현재 위치 근처",
    browseByArea: "지역별 탐색",
    zipcode: "우편번호",
    city: "도시",
    address: "주소",
    getDirections: "길찾기",
    updateLocation: "위치 업데이트",
    locationError: "위치 오류",
    locationPermissionDenied: "위치 접근이 거부되었습니다. 주소를 수동으로 입력하거나 위치 권한을 활성화하세요.",
    locationUnavailable: "위치를 확인할 수 없습니다. 주소로 검색해보세요.",
    locationTimeout: "위치 요청이 시간 초과되었습니다. 다시 시도하거나 수동으로 검색하세요.",
    or: "또는",
    nearbyStations: "근처 충전소",
    newSearch: "새 검색",
    tryDifferentLocation: "다른 위치나 우편번호로 검색해보세요.",
    
    // Distance and availability
    milesAway: "{distance} 떨어짐",
    portsAvailableShort: "{available}/{total} 사용 가능",
    
    // Busyness status badges
    noWait: "대기 없음",
    shortWait: "짧은 대기",
    busy: "혼잡",
    
    // Intelligence section
    busyHours: "혼잡 시간대",
    bestTimes: "최적 시간",
    bestTimesToCharge: "최적 충전 시간",
    shortWaits: "짧은 대기",
    crowded: "혼잡",
    busyHoursDescription: "이 차트는 이 충전소가 하루 종일 얼마나 혼잡한지를 보여줍니다.",
    historyDetails: "24시간 기록 세부정보",
    availableForMinutes: "{minutes}분간 사용 가능",
    inUseForMinutes: "{minutes}분간 사용 중",
    downForMinutes: "{minutes}분간 고장",
    down: "고장",
    
    // Feedback page
    feedbackTitle: "피드백 및 기능 요청",
    feedbackSubtitle: "피드백을 공유하거나 새로운 기능을 제안하여 NoQueue Charge 개선에 도움을 주세요",
    feedbackButton: "피드백 보내기",
    feedbackType: "유형",
    subject: "제목",
    message: "메시지",
    subjectPlaceholder: "피드백에 대한 간단한 설명",
    messagePlaceholder: "자세한 피드백을 제공하거나 원하시는 기능을 설명해주세요...",
    feedbackOption: "일반 피드백",
    featureRequestOption: "기능 요청",
    bugReportOption: "버그 신고",
    otherOption: "기타",
    submitFeedback: "피드백 보내기",
    submitting: "전송 중...",
    feedbackSuccess: "피드백을 보내주셔서 감사합니다!",
    feedbackSuccessMessage: "메시지를 받았으며 곧 검토하겠습니다. 여러분의 의견은 모든 사용자를 위해 NoQueue Charge를 개선하는 데 도움이 됩니다.",
    feedbackError: "피드백 전송 실패",
    feedbackErrorMessage: "피드백 전송 중 오류가 발생했습니다. 나중에 다시 시도해주세요.",
    
    // Coverage information
    coverageStatus: "현재 미국 전역 서비스 중",
    coverageDetails: "전국 1,000+ Electrify America 충전소",

    // Sponsor
    enjoyingApp: "이 앱이 마음에 드시나요?",
    buyMeACoffee: "커피 한 잔 사주기",

    // Privacy Policy
    privacyTitle: "개인정보 처리방침",
    privacyLastUpdated: "최종 업데이트: 2026년 3월 10일",
    privacyIntroTitle: "소개",
    privacyIntroText: "NoQueue Charge(\"당사\")는 귀하의 개인정보 보호에 최선을 다하고 있습니다. 본 개인정보 처리방침은 NoQueue Charge 모바일 앱 및 웹사이트(통칭 \"서비스\")를 사용할 때 당사가 귀하의 정보를 어떻게 수집, 사용, 보호하는지 설명합니다.",
    privacyCollectTitle: "수집하는 정보",
    privacyAccountTitle: "계정 정보",
    privacyAccountEmail: "이메일 주소 (계정 생성 시)",
    privacyAccountName: "표시 이름 (선택사항, 가입 시 제공하는 경우)",
    privacyAccountAuth: "Google 로그인 또는 Apple 로그인의 인증 식별자 (사용하는 경우)",
    privacyLocationTitle: "위치 정보",
    privacyLocationDesc: "근처 충전소를 표시하기 위한 대략적인 위치",
    privacyLocationWhen: "앱 사용 중에만 위치에 접근합니다 (\"사용 중\" 권한)",
    privacyLocationNoTrack: "서버에 위치 기록을 추적하거나 저장하지 않습니다",
    privacyDeviceTitle: "기기 정보",
    privacyDeviceToken: "푸시 알림 토큰 (충전기 가용성 알림 전송용)",
    privacyDeviceType: "기기 유형 및 운영체제 버전 (호환성용)",
    privacyDeviceLang: "언어 설정",
    privacyUsageTitle: "사용 데이터",
    privacyUsageWatch: "감시하도록 선택한 충전소",
    privacyUsageNotif: "설정한 알림 환경설정 및 일정",
    privacyUsagePrefs: "앱 설정 및 환경설정",
    privacyHowUseTitle: "정보 사용 방법",
    privacyHowUseNearby: "귀하의 위치 근처 충전소 표시",
    privacyHowUseNotifs: "감시 중인 충전기가 사용 가능해지면 푸시 알림 전송",
    privacyHowUseAuth: "계정 인증 및 세션 관리",
    privacyHowUseSub: "구독 처리 및 관리",
    privacyHowUseImprove: "서비스 개선 및 버그 수정",
    privacyThirdPartyTitle: "제3자 서비스",
    privacyThirdPartyIntro: "앱 운영을 위해 다음 제3자 서비스를 사용합니다:",
    privacyThirdFirebase: "인증, 푸시 알림 및 충돌 보고",
    privacyThirdRevenueCat: "구독 관리 및 결제 처리",
    privacyThirdMaps: "길안내 및 지도 표시",
    privacyThirdPartyNote: "이러한 서비스는 자체 개인정보 처리방침에 따라 정보를 수집할 수 있습니다. 해당 정책을 검토하시기 바랍니다.",
    privacyNoSellTitle: "데이터를 판매하지 않습니다",
    privacyNoSellText: "광고나 마케팅 목적으로 개인정보를 제3자에게 판매, 대여 또는 공유하지 않습니다. 앱에 광고를 표시하지 않습니다. 귀하의 데이터는 서비스를 제공하고 개선하는 데에만 사용됩니다.",
    privacyRetentionTitle: "데이터 보존",
    privacyRetentionText: "계정이 활성 상태인 동안 계정 정보를 보존합니다. 계정을 삭제하면 30일 이내에 시스템에서 개인 데이터를 삭제합니다. 익명화된 사용 데이터는 분석 목적으로 보존될 수 있습니다.",
    privacyRightsTitle: "귀하의 권리",
    privacyRightsIntro: "귀하는 다음 권리를 가집니다:",
    privacyRightsAccess: "당사가 보유한 귀하의 개인 데이터에 접근",
    privacyRightsDelete: "계정 및 개인 데이터 삭제 요청",
    privacyRightsExport: "이동 가능한 형식으로 데이터 사본 요청",
    privacyRightsOptOut: "앱 또는 기기 설정을 통해 언제든지 푸시 알림 수신 거부",
    privacyRightsHow: "이러한 권리를 행사하려면 support@noqueuecharge.com으로 연락하시거나 앱의 프로필 화면에서 계정 삭제 기능을 사용하세요.",
    privacyChildrenTitle: "아동 개인정보",
    privacyChildrenText: "본 서비스는 13세 미만 아동을 대상으로 하지 않습니다. 13세 미만 아동의 개인정보를 의도적으로 수집하지 않습니다. 그러한 정보를 수집했다고 생각되면 연락 주시면 즉시 삭제하겠습니다.",
    privacyChangesTitle: "정책 변경",
    privacyChangesText: "본 개인정보 처리방침은 수시로 업데이트될 수 있습니다. 중요한 변경 사항은 앱이나 웹사이트에 업데이트된 정책을 게시하여 알려드립니다. 변경 후 서비스를 계속 사용하면 업데이트된 정책에 동의하는 것으로 간주됩니다.",
    privacyContactTitle: "문의하기",
    privacyContactText: "본 개인정보 처리방침이나 개인 데이터에 관한 질문이 있으시면 다음으로 연락해 주세요:",

    // Terms of Use
    termsTitle: "이용약관",
    termsLastUpdated: "최종 업데이트: 2026년 3월 10일",
    termsAcceptTitle: "약관 동의",
    termsAcceptText: "NoQueue Charge(\"앱\")를 다운로드, 설치 또는 사용함으로써 본 이용약관(\"약관\")에 동의하게 됩니다. 본 약관에 동의하지 않는 경우 앱을 사용하지 마세요.",
    termsServiceTitle: "서비스 설명",
    termsServiceText: "NoQueue Charge는 미국 전역의 Electrify America 전기차 충전소에 대한 실시간 정보를 제공합니다. 서비스에는 다음이 포함됩니다:",
    termsServiceMap: "충전 포트 가용 상태가 표시되는 실시간 충전소 지도",
    termsServiceWatch: "충전소를 감시하고 충전기가 사용 가능해지면 알림을 받는 기능",
    termsServiceNotifs: "충전기 가용성 변경에 대한 푸시 알림",
    termsServicePredict: "도착 시 충전기 가용성에 대한 AI 기반 예측",
    termsAccountTitle: "사용자 계정",
    termsAccountText: "일부 기능은 계정 생성이 필요합니다. 계정을 생성하면 다음에 동의하게 됩니다:",
    termsAccountAccurate: "정확하고 완전한 정보 제공",
    termsAccountSecure: "로그인 자격 증명을 안전하게 보관",
    termsAccountResponsible: "계정 하의 모든 활동에 대한 책임",
    termsSubTitle: "구독 및 결제",
    termsSubFreeTitle: "무료 요금제",
    termsSubFreeText: "앱은 무료로 사용하여 모든 충전소를 탐색하고, 실시간 포트 상태를 확인하고, 길안내를 받을 수 있습니다. 일부 고급 기능은 유료 구독이 필요합니다.",
    termsSubProTitle: "NoQueue Pro",
    termsSubProText: "NoQueue Pro는 월 $2.99의 월간 구독으로 제공됩니다. Pro 기능에는 최대 5개 충전소 감시, 60초 실시간 알림, 맞춤형 알림 일정, 혼잡 시간대 패턴 및 AI 스마트 알림이 포함됩니다.",
    termsSubAutoTitle: "자동 갱신",
    termsSubAutoText: "구독은 현재 기간 종료 최소 24시간 전에 취소하지 않는 한 각 청구 기간이 끝날 때 자동으로 갱신됩니다. Apple ID 또는 Google Play 계정은 현재 기간 종료 24시간 이내에 동일한 가격으로 갱신 요금이 청구됩니다. 기기의 구독 설정에서 구독을 관리하고 취소할 수 있습니다.",
    termsSubCancelTitle: "취소",
    termsSubCancelText: "Apple App Store 또는 Google Play Store의 구독 설정을 통해 언제든지 구독을 취소할 수 있습니다. 취소는 현재 청구 기간이 끝날 때 적용됩니다. 부분 청구 기간에 대한 환불은 제공되지 않습니다.",
    termsDisclaimerTitle: "면책 조항",
    termsDisclaimerText: "다음 사항에 유의하세요:",
    termsDisclaimerAccuracy: "충전소 데이터는 \"있는 그대로\" 제공됩니다. 정확성을 위해 노력하지만 상태 정보가 항상 최신이거나 정확하다고 보장할 수 없습니다.",
    termsDisclaimerDelay: "충전기의 실제 상태 변경과 앱에 표시되는 것 사이에 지연이 있을 수 있습니다.",
    termsDisclaimerPredict: "AI 예측은 과거 패턴을 기반으로 한 추정치이며 여행 계획 결정의 유일한 근거로 사용해서는 안 됩니다.",
    termsDisclaimerAffiliate: "NoQueue Charge는 독립적인 앱입니다. Electrify America 또는 어떤 충전 네트워크와도 제휴, 승인 또는 후원 관계가 없습니다.",
    termsUseTitle: "허용되는 사용",
    termsUseText: "귀하는 다음을 하지 않기로 동의합니다:",
    termsUseNoReverse: "앱을 리버스 엔지니어링, 디컴파일 또는 역어셈블",
    termsUseNoAbuse: "불법적인 목적이나 본 약관을 위반하여 앱 사용",
    termsUseNoAutomate: "합리적인 사용을 초과하는 방식으로 자동화 시스템이나 봇을 사용하여 앱에 접근",
    termsUseNoResell: "앱이나 데이터에 대한 접근을 재판매, 재배포 또는 재라이선스",
    termsIpTitle: "지적 재산권",
    termsIpText: "디자인, 기능, 코드 및 콘텐츠를 포함한 앱은 NoQueue Charge가 소유하며 지적 재산권법에 의해 보호됩니다. 귀하에게는 개인적, 비상업적 목적으로 앱을 사용할 수 있는 제한적, 비독점적, 양도 불가능한 라이선스가 부여됩니다.",
    termsTerminationTitle: "종료",
    termsTerminationText: "본 약관을 위반하는 경우 언제든지 앱에 대한 접근을 일시 중지하거나 종료할 수 있습니다. 앱의 프로필 화면을 통해 언제든지 계정을 삭제할 수 있습니다. 종료 시 앱 사용 권리가 즉시 중단됩니다.",
    termsLiabilityTitle: "책임 제한",
    termsLiabilityText: "법률이 허용하는 최대 범위 내에서 NoQueue Charge는 앱 사용으로 인한 간접적, 부수적, 특별, 결과적 또는 징벌적 손해에 대해 책임을 지지 않습니다. 여기에는 충전기 가용성 정보에 대한 의존, 충전 기회 상실 또는 여행 지연으로 인한 손해가 포함되지만 이에 국한되지 않습니다. 당사의 총 책임은 청구 전 12개월 동안 앱에 대해 지불한 금액을 초과하지 않습니다.",
    termsChangesTitle: "약관 변경",
    termsChangesText: "본 약관은 수시로 업데이트될 수 있습니다. 중요한 변경 사항은 앱이나 웹사이트에 업데이트된 약관을 게시하여 알려드립니다. 변경 후 앱을 계속 사용하면 업데이트된 약관에 동의하는 것으로 간주됩니다.",
    termsGoverningTitle: "준거법",
    termsGoverningText: "본 약관은 법률 충돌 조항에 관계없이 미국 캘리포니아주 법률에 의해 규율되고 해석됩니다.",
    termsContactTitle: "문의하기",
    termsContactText: "본 약관에 관한 질문이 있으시면 다음으로 연락해 주세요:",
    termsViewPrivacy: "개인정보 처리방침 보기",

    // App promotion
    getAppAlerts: "충전기 알림 받기",
    getAppAlertsDesc: "충전기가 사용 가능해지면 알림을 받으세요",
    arrivalPrediction: "출발 전에 확인하기",
    arrivalPredictionDesc: "도착 시 충전기가 사용 가능한지 미리 알 수 있습니다",
    downloadApp: "App Store에서 다운로드",
    openInApp: "앱에서 열기",
    getApp: "앱 받기",
    scanToDownload: "스캔하여 다운로드",
    comingSoonAndroid: "Android 버전 출시 예정",
    appPromoTitle: "충전 대기는 이제 그만",
    appPromoFeature1: "포트 사용 가능 시 즉시 알림",
    appPromoFeature2: "AI가 도착 시 가용 여부 예측",
    appPromoFeature3: "여러 충전소 동시 모니터링",
    tryTheApp: "더 나은 경험을 위해 앱을 사용해 보세요",
    viewInAppStore: "보기",
    appName: "NoQueue Charge",
    appTagline: "무료 - 실시간 EV 충전",
    notifyEmail: "Android 출시 시 알림 받을 이메일",
    textMeTheApp: "링크 보내기",
    enterPhone: "전화번호",
    orDivider: "또는",
    appPopupTitle: "앱으로 더 스마트하게 충전하세요",
    appPopupDesc: "실시간 알림, AI 예측, 충전소에서 더 이상 기다리지 마세요."
  }
};

export const languageNames = {
  en: "English",
  es: "Español", 
  zh: "中文",
  ko: "한국어"
}; 